"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _LatestCollections = _interopRequireDefault(require("../LatestCollections"));
var __jsx = _react.default.createElement;
var UpcomingEventsGrid = function UpcomingEventsGrid(_ref) {
  var totalEventsDisplay = _ref.totalEventsDisplay,
    events = _ref.events,
    ctaLink = _ref.ctaLink,
    openNewTab = _ref.openNewTab,
    anchorId = _ref.anchorId,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'aem-ms-upcoming-events-grid' : _ref$className,
    _ref$translations = _ref.translations,
    translations = _ref$translations === void 0 ? {
      moreEvents: 'More Events',
      upcomingEvents: 'Upcoming Events'
    } : _ref$translations;
  return __jsx(_LatestCollections.default, {
    anchorId: anchorId,
    heading: translations.upcomingEvents,
    totalEventsDisplay: totalEventsDisplay,
    items: events,
    ctaTitle: translations.moreEvents,
    ctaLink: ctaLink,
    openNewTab: openNewTab,
    className: className
  });
};
var UpcomingEventsGridEditConfig = {
  emptyLabel: 'Configure Upcoming Events Grid',
  isEmpty: function isEmpty(props) {
    if (props.events && props.events.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/upcomingeventsgrid')(UpcomingEventsGrid, UpcomingEventsGridEditConfig);
exports.default = _default;